import React from "react";

// Renders the predefined (admin-seeded, per-industry) fields for a
// customer asset plus an ad-hoc key/value custom-fields list, matching
// ItemFormDrawer.jsx's "+ Add attribute" pattern but restyled with plain
// inline styles (no react-bootstrap dependency) using the exact tokens
// CustomerProfile.jsx's Addresses card already uses, so this looks native
// whether it's dropped into that screen's pure-inline-style convention or
// wrapped in Bookings.jsx's Bootstrap-based section card.
const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  borderRadius: 8,
  border: "1.5px solid #e2e8f0",
  fontSize: 13,
  boxSizing: "border-box",
  outline: "none",
  fontFamily: "inherit",
};
const labelStyle = { display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 5 };

const AssetFieldsForm = ({ fieldDefs = [], values = {}, onChange, customFields = [], onCustomFieldsChange }) => {
  const setCustomField = (idx, key, val) => {
    const next = customFields.map((f, i) => (i === idx ? { ...f, [key]: val } : f));
    onCustomFieldsChange(next);
  };

  return (
    <div>
      {/* auto-fit grid: sits several fields per row when there's room (e.g.
          the wide Booking screen), collapses to one field per row on its
          own once the container gets narrow (e.g. the Customer screen's
          460px modal, or any mobile viewport) - no separate breakpoint
          logic needed for each host screen. */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 12, marginBottom: fieldDefs.length ? 12 : 0 }}>
        {fieldDefs.map((f) => (
          <div key={f.field_key}>
            <label style={labelStyle}>
              {f.field_label}{f.is_required ? " *" : ""}
            </label>
            {f.field_type === "select" ? (
              <select
                value={values[f.field_key] || ""}
                onChange={(e) => onChange(f.field_key, e.target.value)}
                style={{ ...inputStyle, background: "#fff" }}
              >
                <option value="">Select {f.field_label}</option>
                {(f.field_options || []).map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            ) : (
              <input
                type={f.field_type === "number" ? "number" : f.field_type === "date" ? "date" : "text"}
                value={values[f.field_key] || ""}
                onChange={(e) => onChange(f.field_key, e.target.value)}
                style={inputStyle}
              />
            )}
          </div>
        ))}
      </div>

      <div style={{ marginTop: fieldDefs.length ? 6 : 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>Additional details</span>
          <button
            type="button"
            onClick={() => onCustomFieldsChange([...customFields, { key: "", value: "" }])}
            style={{ border: "none", background: "none", color: "#4f46e5", fontSize: 12, fontWeight: 700, cursor: "pointer", padding: 0 }}
          >
            + Add field
          </button>
        </div>
        {customFields.map((cf, idx) => (
          // flex-wrap + a fixed min-width basis (not percentages) so each
          // input drops to its own line once the row is too narrow to fit
          // both side by side, instead of squeezing them illegibly thin.
          <div key={idx} style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8, alignItems: "center" }}>
            <input
              placeholder="Label"
              value={cf.key}
              onChange={(e) => setCustomField(idx, "key", e.target.value)}
              style={{ ...inputStyle, flex: "1 1 140px" }}
            />
            <input
              placeholder="Value"
              value={cf.value}
              onChange={(e) => setCustomField(idx, "value", e.target.value)}
              style={{ ...inputStyle, flex: "2 1 160px" }}
            />
            <button
              type="button"
              onClick={() => onCustomFieldsChange(customFields.filter((_, i) => i !== idx))}
              style={{ border: "none", background: "none", cursor: "pointer", color: "#dc2626", fontSize: 15, flexShrink: 0, padding: "0 4px" }}
              title="Remove"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssetFieldsForm;
